import gsap from "gsap";
import * as PIXI from 'pixi.js';
import { IInterval } from "../Context/Interval";
import { ISystemContext } from "../Context/SystemContext";
import { CreateElement, Log, MyPIXIContainer, Safe, SetNullReference } from "../MyHelpers";
import { RegisterPixi, UnregisterPixi } from "../PixiDebug";
import { ResourceIdentifier } from "../ResourceManager/ResourceIdentifier";
import { Settings } from "../Settings";
import { FrontendErrorCode } from "../api";
import { service } from "../services";
import { assertTrue } from "../debug";
import { Spine } from "../PixiSpineRuntime";


export class GameEngine {
	protected logGroup: string = "GameViewEngineAppPixi";
	//public pixiContainercanvas: PIXI.Container[][] = [];
	//public pixiCanvas: PIXI.AnimatedSprite[][] = [];
	protected resid: ResourceIdentifier;
	protected systemContext: ISystemContext = null;
	protected restoreWebGlInterval: IInterval = null;
	protected garbageCollectorInterval: IInterval = null;
	protected view: HTMLElement = null;
	//protected gameName : string = null;
	protected fixScreens: number = 3;

	public constructor(resid: ResourceIdentifier, systemContext: ISystemContext) {
		this.resid = resid.Add("GameViewEngineAppPixi");
		this.systemContext = systemContext.CreateSubContext("GameViewEngineAppPixi");
		//this.gameName = gameName;
		this.fixScreens = Settings.ScreenHeight * Settings.Screens;
		//if(Settings.Enable2plus1) this.fixScreens =  Settings.ScreenHeight * (Settings.Screens - 1);
		this.view = CreateElement("div", {
			classes: [`GameViewEngineAppPixi-SlotWindow`], style: {
				//display : "flex",
				width: "100%",
				height: this.fixScreens + "px",
				bottom: "0px",
				position: "absolute",
				zIndex: "1",
			}
		});

		this.restoreWebGlInterval = this.systemContext.TimingContext().CreateInterval("restoreWebGlInterval", 500, () => {
			let success = this.tryRecoverWebglContext();

			// success, stop timer
			if (!success) {
				this.recoverFailCount++;

				if (this.recoverFailCount == this.maxRecoverFailCount) {
					void service.api.frontendError(FrontendErrorCode.WebGLRecoverFail, `${this.resid.ID()} in ${this.recoverFailCount} tries`);
				}
			}
		});

		this.garbageCollectorInterval = this.systemContext.TimingContext().CreateInterval("restoreWebGlInterval", 1000 * 60 * 30 , () => {
			(this.app.renderer as unknown as PIXI.Renderer).textureGC.run();
			//gsap.globalTimeline.clear(true);
			//console.log("Limpieza automática de texturas y timelines");
		});
	}

	public app: PIXI.Application<HTMLCanvasElement> = null;
	public GetView(): HTMLElement {
		return this.view;
	}

	public GetAppView(): PIXI.Application<HTMLCanvasElement> {
		return this.app;
	}

	protected lastCleanup = 0;


	//update canvas render 
	public Update() {
		this.app?.ticker?.update();
	

		//app.renderer.render(app.stage);
	}

	protected created: boolean = false;
	protected isTryDestroy: boolean = false;
	public Destroy() {
		this.isTryDestroy = true;
		this.InternalDestroy();
		this.created = false;
		this.restoreWebGlInterval.Stop();
	}

	protected InternalDestroy() {

		if (!this.created) {
			Log.Debug(this.logGroup, `Destroy(): no app, not destroying anything`);
			return;
		}


		try {
			if (this.gameContainer.parent != null)
			{
				this.gameContainer.removeFromParent();
			}
			
			if (this.jackpotContainer.parent != null)
			{
				this.jackpotContainer.removeFromParent();
			}
		}
		catch (ex) {
			Log.Error(this.logGroup, `Destroy(): error removing containers maybe was removed  ${ex.toString()}`);
		}

		if (this.app != null) {

			// // 1. Intenta perder el contexto WebGL (liberar GPU)
			//Safe(()=>this.ClearContext());
			gsap.killTweensOf(this.app);
			this.app.view.removeEventListener('webglcontextlost', this.webglcontextlostInstance)



			this.app.destroy(true, true);


			UnregisterPixi(this.app, this.resid);

			this.app = null;
		}

		try
		{
			this.OnDestroyCallback?.();
		}
		catch(ex)
		{
			void service.api.frontendError(FrontendErrorCode.UnknownFrontendError, `Error in GameEngine OnDestroyCallback ${this.resid.ID()}, error: ${ex.toString()}`);
		}
	}

	protected ClearContext() {
		let gl = (this.app?.renderer as any)?.gl;
		const loseContextExt = gl?.getExtension('WEBGL_lose_context');
		if (loseContextExt) {
			loseContextExt?.loseContext(); // <- fuerza la pérdida del contexto GPU
		}
		gl = null
	}

	public Create() {
		if (this.created) {
			// already created
			return;
		}

		this.created = true;
		this.isTryDestroy = false;
		try {
			this.InternalCreate();
		}
		catch (ex) {
			this.restoreWebGlInterval.Start();
		}
	}

	protected gameContainer: PIXI.Container = null;
	protected jackpotContainer: PIXI.Container = null;
	protected InternalCreate() {
		if (!this.created) {
			Log.Error(this.logGroup, `Create(): app not null, don't recreate`);
			return;
		}

		this.garbageCollectorInterval.Stop();

		let app = new PIXI.Application<HTMLCanvasElement>({
			width: Settings.ScreenWidth,
			height: this.fixScreens,
			backgroundAlpha: 0,			
			//transparent: true,
			//resolution: 1,
			//autoDensity: true,
			antialias: false,
			//backgroundColor : "blue",		             
			//forceCanvas: false,
			preserveDrawingBuffer: false,
			// view: canvas,
			// context: context,
			autoStart : false,			
			
		});

		this.app = app;

		this.app.ticker.stop();
		this.app.stage.accessibleChildren = true;
		this.app.stage.accessible = true
		this.app.stage.sortableChildren = true;
		//this.app.stage.interactive = true;
		this.app.view.addEventListener("webglcontextlost", this.webglcontextlostInstance);
		this.app.stage.name = this.resid.ScopedResourceName();
		RegisterPixi(this.app, this.resid);

		globalThis.__PIXI_APP__ = this.app;


		this.app.stop(); // use custom ticker	

		this.view.appendChild(this.app.view);

		this.app.view.style.bottom = "0px";
		this.app.view.style.position = "relative";
		this.app.view.style.overflow = "hidden";

		(this.app.renderer as unknown as PIXI.Renderer).textureGC.maxIdle = 60 * 2; // destruye si no se usa en 2 minutos
		
		(this.app.renderer as unknown as PIXI.Renderer).textureGC.mode = PIXI.GC_MODES.AUTO;		
		if(this.gameContainer == null )
		{
			this.gameContainer = new MyPIXIContainer(this.resid.ScopedResourceName("Container"), () => {
				console.log(new Error("Game Container Destroyed"));
				debugger;
			});
		}
		this.gameContainer.sortableChildren = true;

		
		if(this.jackpotContainer == null )
		{
			this.jackpotContainer = new MyPIXIContainer(this.resid.ScopedResourceName("Jackpot-Container"), () => {
				console.log(new Error("Jackpot Container Destroyed"));
				debugger;
			});
			this.jackpotContainer.sortableChildren = true;
		}
		
		assertTrue(!(this.gameContainer as any)._destroyed);
		this.app.stage.addChild(this.gameContainer)
		
		assertTrue(!(this.jackpotContainer as any)._destroyed);
		this.app.stage.addChild(this.jackpotContainer)

		try
		{
			this.garbageCollectorInterval.Start();
			this.OnCreatedCallback?.();
		}
		catch(ex)
		{
			this.garbageCollectorInterval.Stop();
			void service.api.frontendError(FrontendErrorCode.UnknownFrontendError, `Error in GameEngine OnCreatedCallback ${this.resid.ID()}, error: ${ex.toString()}`);
		}
	}

	protected TestApp(): boolean
	{
		// test if app can be created

		let testApp: PIXI.Application<HTMLCanvasElement> = null;
		try
		{
			testApp = new PIXI.Application<HTMLCanvasElement>({
				width: 300,
				height: 300,
			});
			testApp.destroy(true, true);
			testApp = null;
			return true;
		}
		catch(ex)
		{
			testApp = null;
			return false;
		}
	}

	protected recoverCount: number = 0;
	protected recoverFailCount: number = 0;
	protected readonly maxRecoverFailCount = 5;

	protected async tryRecoverWebglContext(): Promise<boolean> {
		if (!this.created) {
			this.restoreWebGlInterval.Stop();
			this.recoverFailCount = 0;

			// app not created, don't care
			return true;
		}

		// test if webgl is available again

		console.log(this.resid.ID() + " trying to recover");

		const canCreate = this.TestApp();
		if (!canCreate) {
			console.log(this.resid.ID() + " still cannot create webgl context");
			return false;
		}
		

		await service.api.frontendError(FrontendErrorCode.WebGLContextRecovering, `${this.resid.ID()}`);
		try {
			await service.api.frontendError(FrontendErrorCode.WebGLDestroy, `${this.resid.ID()}`);
			this.InternalDestroy();
			await service.api.frontendError(FrontendErrorCode.WebGLDestroySuccess, `${this.resid.ID()}`);
		}
		catch (ex) {
			await service.api.frontendError(FrontendErrorCode.WebGLDestroyError, `${this.resid.ID()}: ${ex.toString()}`);
		}

		try {
			// Log.Debug(this.logGroup, `tryRecoverWebglContext() ${this.resid.ID()} recreating`);
			await service.api.frontendError(FrontendErrorCode.WebGLCreate, `${this.resid.ID()}`);
			this.InternalCreate();

			// all fine, stop timer
			this.restoreWebGlInterval.Stop();
			console.log(this.resid.ID() + " recover success");

			this.recoverCount++;
			this.restoreWebGlInterval.Stop();
			this.recoverFailCount = 0;

			await service.api.frontendError(FrontendErrorCode.WebGLCreateSuccess, `${this.resid.ID()}`);
			await service.api.frontendError(FrontendErrorCode.WebGLContextRecovered, `${this.resid.ID()}, recover count: ${this.recoverCount}`);

			return true;
		}
		catch (ex) {
			console.log(this.resid.ID() + " error recovering", ex);

			// prevent spamming the backend
			if (this.recoverFailCount < this.maxRecoverFailCount) {
				await service.api.frontendError(FrontendErrorCode.WebGLCreateError, `${this.resid.ID()}, ${ex.toString()}`);

				if (ex.message.toLowerCase().includes("this browser does not support webgl")) {
					await service.api.frontendError(FrontendErrorCode.WebGLNotSupported, `${this.resid.ID()}, error: ${ex.toString()}`);
				}
				else {
					await service.api.frontendError(FrontendErrorCode.WebGLRecoverError, `${this.resid.ID()}, error: ${ex.toString()}`);
				}
			}
		}

		return false;
	};

	protected async webglcontextlost() {
		Log.Error(this.logGroup, `Webgl context lost`);
		await service.api.frontendError(FrontendErrorCode.WebGLContextLost, "Webgl context lost");

		// try recover right now, or start timer to try recover later
		let success = this.tryRecoverWebglContext();
		if (success) {
			// all good
			return;
		}

		// error recovering, start timer
		this.restoreWebGlInterval.Start();
	}

	protected webglcontextlostInstance: () => void = this.webglcontextlost.bind(this);
	public OnCreatedCallback: OnCreatedEngineAppPixiCallbackHandler = null;

	public OnDestroyCallback: OnDestroyEngineAppPixiCallbackHandler = null;
	public GameEngineWasCreated(): boolean {
		return this.created;
	}

	public GetViewGame() {
		return this.gameContainer
	}

	public GetViewJackpot() {
		return this.jackpotContainer
	}

	public CollecGarbage() {
		if(!this.app) return
		const tweens = gsap.globalTimeline.getChildren()
		console.log("Limpieza de cambio de juego de texturas y timelines Childens" , tweens)
		gsap.globalTimeline.getChildren().forEach((tween) => {
			if(tween.vars.id && tween.vars.id.toString().startsWith("JackpotScrollDigit-Anim-")){
				console.log("Limpieza de cambio de juego de texturas y timelines- jackpotRunning", tween.vars.id)
				return;
			}
			else if (tween && tween.progress() >= 1 && !tween.isActive()) {
				tween.kill();
			}
		});
		(this.app?.renderer as unknown as PIXI.Renderer).textureGC.run();
		//gsap.globalTimeline.clear(false);
		//console.log("Limpieza de cambio de juego de texturas y timelines");		
	}
	
}

export type OnCreatedEngineAppPixiCallbackHandler = () => void;
export type OnDestroyEngineAppPixiCallbackHandler = () => void;
